import React from 'react';

export default function About() {
    return (
        <div className="text-center">
            <h1>Not Found</h1>
            <p>Requested page not found</p>
        </div>
    )
}
